import React from 'react';
import 'antd/dist/antd.css';
import { Form, Input, Collapse, Button, Select, Row, Col, Progress } from 'antd';
import { MUIFeatherCheckIcon, MUIFeatherCheckEmptyIcon } from '../../../../assets/svgToIconCovert';
import "./customStyle.css";
import ReportStatusChart from "./ReportStatusChart";

import {connect} from 'react-redux'

class ComplianceSummary extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            winWidth: window.innerWidth,
            winHeight: window.innerHeight,
        }
        this.updateDimensions = this.updateDimensions.bind(this);
    }

    updateDimensions = () => {
        this.setState({
            winWidth: window.innerWidth,
            // winHeight: window.innerHeight 
        });
    }

    componentDidMount() {
        window.addEventListener("resize", () => this.updateDimensions());
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.updateDimensions());
    }
    render(){
        return(
            <div>
                <Row className="summarySection"> 
                    <Col xs={24} sm={24} md={18} lg={16} xl={18} xxl={16}>
                        {(this.props.status === "All" || this.props.status === "Report Status" )?(
                            <Row className="progressSection" gutter={[8,16]}>
                                <Col xs={7} sm={7} md={4} lg={4} xl={3} xxl={3} className="progressSectionType">
                                    Report
                                </Col>
                                <Col xs={14} sm={14} md={18} lg={18} xl={19} xxl={19}>
                                    <ReportStatusChart
                                        percentage={this.props.compliantPercentage}
                                    />
                                </Col>
                                <Col xs={3} sm={3} md={2} lg={2} xl={2} xxl={2}>
                                    {(this.props.compliantPercentage === 100) ? (<MUIFeatherCheckIcon />) : (<MUIFeatherCheckEmptyIcon />)}
                                </Col>
                            </Row>
                        ):<></> }
                        {(this.props.status === "All" || this.props.status === "Signature Status" )?(
                            <Row className="progressSection" gutter={[8,16]}>
                                <Col xs={7} sm={7} md={4} lg={4} xl={3} xxl={3} className="progressSectionType">
                                    Signature
                                </Col>
                                <Col xs={14} sm={14} md={18} lg={18} xl={19} xxl={19}>
                                    <ReportStatusChart
                                        percentage={this.props.signaturePercentage}
                                    />
                                </Col>
                                <Col xs={3} sm={3} md={2} lg={2} xl={2} xxl={2}>
                                {(this.props.signaturePercentage === 100) ? (<MUIFeatherCheckIcon />) : (<MUIFeatherCheckEmptyIcon />)}
                                </Col>
                            </Row>
                        ):<></> }
                        
                    </Col>
                    <Col xs={24} sm={24} md={6} lg={8} xl={6} xxl={8}>
                        <Row gutter={[8,16]} className="legend">
                            <Col xs={7} sm={7} md={4} lg={4} xl={3} xxl={3}></Col>
                            <Col 
                                // xs={10} sm={8} md={24} lg={24} xl={24} xxl={24}
                                xs={7} sm={7} md={20} lg={20} xl={21} xxl={21}
                                className="box"
                                style={(this.state.winWidth < 768 )? {fontSize:'10px'} : {fontSize:'12px'}}><span className="greenBox"></span> Compliant</Col>
                            <Col xs={0} sm={0} md={4} lg={4} xl={3} xxl={3}></Col>
                            <Col 
                                // xs={14} sm={16} md={24} lg={24} xl={24} xxl={24}
                                xs={10} sm={10} md={20} lg={20} xl={21} xxl={21}
                                className="box"
                                style={(this.state.winWidth < 768 )? {fontSize:'10px'} : {fontSize:'12px'}}><span className="redBox"></span> Non - Compliant</Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(state){
    // console.log("SUMMARY 1", state)
    return {
        status : state.complianceTableReducer.status
    }
  }
  
function matchDispatchToProps(dispatch){
    return {}
}

export default connect(mapStateToProps, matchDispatchToProps)(ComplianceSummary);


          
     